import { defineMessages } from 'react-intl-next';

export default defineMessages({
    modalDescription: {
		id: 'dev-agents.home.code-reviewer-settings.bbc-workspaces-modal.modal-description',
		defaultMessage: 'To enable Code Reviewer on other workspaces, go to workspace settings in Bitbucket and select Rovo Dev Agents.',
		description: 'The description in the body of the modal that allows users to choose a workspace to enable Code Reviewer.',
	},
    seeAllWorkspaces: {
		id: 'dev-agents.home.code-reviewer-settings.bbc-workspaces-modal.see-all-workspaces',
		defaultMessage: 'See all workspaces.',
		description: 'The link text for the link to the Bitbucket workspaces page.',
	},
});
